import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import InvoicesIssueDialog from "invoice/component/invoicesIssueDialog";
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PageProps, PERMISSION, SECURABLE} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {PARTYCATEGORY, PARTYROLE} from "party/partyDomain";
import {BulkAction, BULKACTIONTYPE} from "core/grid/component/gridComp";
import Grid from "core/grid/domain/grid";
import {loc} from "core/common/config/locales";
import securityService from "core/security/securityService";
import {RESTRICTION} from "core/security/securityDomain";

const gridLocation = 'partyCustomers';

@observer
export default class CustomerList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.party;
  static title = loc.i18n`Customers`;
  static icon = 'male';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("CustomerList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }


  private invoicesIssueDialogRef: InvoicesIssueDialog;

  invoicesIssueDialogRefHandler = comp => this.invoicesIssueDialogRef = comp;

  issueInvoices = (grid: Grid) => {

    new Promise((resolve, reject) => {
      this.invoicesIssueDialogRef.open(resolve, reject, grid);
    }).catch( (error) => {
      console.log('rejecting InvoicesIssueDialog with ', error);
      if (error)  {
        if (error.response && error.response.data && error.response.data.severity === 'ERROR') {
          grid.errors = error.response.data.messages;
        } else {
          throw error;
        }
      }
    });
  };



  render() {
    let {params, query} = this.props;



    let bulkActions: BulkAction[] = [{type: BULKACTIONTYPE.ACTION, label: loc.i18n`Issue Invoices`, fn: this.issueInvoices, that:this, securable: SECURABLE.issueInvoices}];


    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}
                           bulkActions={bulkActions} multiUpdateSecurable={SECURABLE.partyGridUpdate} >
          <ZzFlatButtonRoute onGridToolbar routeName="partyDetail" params={{id: 'new'}} query={{partyCategory: PARTYCATEGORY.CO, roles:PARTYROLE.CUSTOMER_ROLE}} label={loc.i18n`New Customer`} permission={PERMISSION.New}/>

          <InvoicesIssueDialog ref={this.invoicesIssueDialogRefHandler} entities={mdEntityService.entityMap} />
        </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/party/page/customerList.tsx